<template>
    <el-cascader ref="yushuAreaCascader" v-model="selectedArea" :options="areas" :props="{ expandTrigger: 'hover' }" style="min-width:300px" @change="onChangeArea"></el-cascader>
</template>
<script>
import TotalAreas from './area.json';
export default {
    name: "YushuAreaCascader",
    props: ['bean'],
    data() {
        return {
            areas: TotalAreas,
            selectedArea: []
        }
    },
    mounted() {
        if (this.bean) {
            if (this.bean.areaProvince && this.bean.areaCity && this.bean.areaDistrict) {
                let p = [this.bean.areaProvince.toString(), this.bean.areaCity.toString(), this.bean.areaDistrict.toString()];
                Vue.set(this, 'selectedArea', p);
                return;
            }
        }
        Vue.set(this, 'selectedArea', []);
    },
    watch: {
        bean: {
            async handler(val) {
                if (val) {
                    if (this.bean.areaProvince && this.bean.areaCity && this.bean.areaDistrict) {
                        let p = [this.bean.areaProvince.toString(), this.bean.areaCity.toString(), this.bean.areaDistrict.toString()];
                        Vue.set(this, 'selectedArea', p);
                        return;
                    }
                }
                Vue.set(this, 'selectedArea', []);
            },
            immediate: true,
        },
    },
    methods: {
        onChangeArea(val) {
            if (val && val.length == 3) {
                let p = this.$refs.yushuAreaCascader.getCheckedNodes(false);
                let labels = p[0].pathLabels;
                let data = {
                    provinceCode: val[0],
                    provinceName: labels[0],
                    cityCode: val[1],
                    cityName: labels[1],
                    regionCode: val[2],
                    regionName: labels[2]
                };
                this.$emit('onAreaChanged', data);
            }
        }
    }
}
</script>